import { Component } from '@angular/core';

@Component({
  selector: 'app-idcard3',
  templateUrl: './idcard3.component.html',
  styleUrls: ['./idcard3.component.scss'],
  standalone:false
})
export class Idcard3Component {

}
